export class DynamicConfig {
  static getOrigin() {
    return location.host;
  }
}
